import { reset, root } from "./root.js";
import { variables } from "./root.js";
import * as accessibility$1 from "./accessibility.js";
import * as animation$1 from "./animation.js";
import * as element$1 from "./element.js";
import * as layout$1 from "./layout.js";
import * as tokenNamespace from "@universityofmaryland/web-token-library";
import * as typography$1 from "./typography.js";
import { webComponentStyles } from "./web-components.js";
import * as utilities$1 from "./utilities.js";
import { toString } from "./utilities/create/style.js";
import { formatNestedObjects } from "./utilities/transform/jss.js";
import { typographyFontFaceObject } from "./typography/font-face/index.js";
const preRender = {
  ...root,
  ...reset,
  ...webComponentStyles
};
const preRenderCss = toString(preRender);
const postRender = {
  ...formatNestedObjects({
    accessibilityNamespace: accessibility$1,
    animationsNamespace: animation$1,
    elementNamespace: element$1,
    layoutNamespace: layout$1,
    typographyNamespace: typography$1
  })
};
const postRenderCss = toString(postRender);
const outputStyles = {
  ...typographyFontFaceObject,
  ...preRender,
  ...postRender
};
const accessibility = accessibility$1;
const animation = animation$1;
const element = element$1;
const layout = layout$1;
const typography = typography$1;
const token = tokenNamespace;
const webComponents = webComponentStyles;
const utilities = utilities$1;
export {
  accessibility,
  animation,
  element,
  layout,
  outputStyles,
  postRender,
  postRenderCss,
  preRender,
  preRenderCss,
  reset,
  root,
  token,
  typography,
  utilities,
  variables,
  webComponents
};
//# sourceMappingURL=index.js.map
